{
  "cms.unpublish.success": "Poistettu julkaisusta.",
  "cms.archive.success": "Arkistoitu.",
  "cms.schedule.success.saved": "Ajastus tallennettu.",
  "cms.schedule.success.changed": "Ajastus muutettu.",
  "cms.schedule.success.cancelled": "Ajastus peruttu.",
  "cms.order.success.published": "Järjestys julkaistu.",
  "cms.order.success.discarded": "Järjestysmuutos hylätty."
}
